import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "matched",
  "use": "matched-usage",
  "viewBox": "0 0 21.3 15.9",
  "content": "<symbol viewBox=\"0 0 21.3 15.9\" id=\"matched\"><path d=\"M0 10.6h21.3v5.3H0v-5.3zM0 0v5.3h21.3V0H0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/matched.svg
// module id = /Fcg
// module chunks = 1